import { render, staticRenderFns } from "./goods_order.vue?vue&type=template&id=75af43c0&scoped=true"
import script from "./goods_order.vue?vue&type=script&lang=js"
export * from "./goods_order.vue?vue&type=script&lang=js"
import style0 from "./goods_order.vue?vue&type=style&index=0&id=75af43c0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "75af43c0",
  null
  
)

export default component.exports